import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0035',
    ecrans: ['00-2']
});
